var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:("button-form-item_" + (_vm.item.id)),attrs:{"buttonStyle":_vm.style,"label":_vm.options.text}})}
var staticRenderFns = []

export { render, staticRenderFns }